import { Copy } from "lucide-react";
import { Button } from "./ui/button";
import { useToast } from "./ui/use-toast";
import { Input } from "./ui/input";

interface QrCodeProps {
    Valor: number,
    DataVencimento: string,
    QrCode: string,
    QrCodeText: string,
    IdFatura?: string,
    abrirModalCancelarFatura: () => void
}

export function QrCode(props: QrCodeProps) {
    const { toast } = useToast()

    return (
        <div className="flex flex-col md:flex-row">
            <div className="md:w-[70%]">
                <p className="flex justify-center text-2xl text-primary-foreground">Aguardando Pagamento</p>
                <p className="flex justify-center text-lg text-primary-foreground">Valor: {props.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                <p className="flex justify-center text-lg text-primary-foreground">Data Vencimento: {props.DataVencimento}</p>

                <div className="flex justify-center">
                    <img src={(props.QrCode.indexOf('http') < 0 ? "data:image/png;base64, " : '') + props.QrCode} alt="Imagem do QrCode" />
                </div>
            </div>
            <div className="self-center w-full">
                <div className="flex flex-col justify-center px-10 gap-3 mb-10">
                    <Input readOnly value={props.QrCodeText} type="text" />
                    <Button className="self-center gap-2 w-full" onClick={async () => {
                        await navigator.clipboard.writeText(props.QrCodeText);
                        toast({
                            variant: 'success',
                            description: 'Código copiado com sucesso!',
                            duration: 3000
                        })
                    }}><Copy />Copiar Pix Copia e Cola</Button>
                </div>
                {
                    props?.IdFatura && (
                        <div className="px-9 mt-4">
                            <Button onClick={() => props.abrirModalCancelarFatura()} className="w-full" variant='destructive'>
                                Cancelar Fatura
                            </Button>
                        </div>
                    )
                }
            </div>
        </div>
    )
}